import { render, staticRenderFns } from "./OrderSizeTable.vue?vue&type=template&id=34e6ae28&scoped=true"
import script from "./OrderSizeTable.vue?vue&type=script&lang=js"
export * from "./OrderSizeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e6ae28",
  null
  
)

export default component.exports